export enum ScormStatus {
  PASSED = 'passed',
  COMPLETED = 'completed', 
  FAILED = 'failed',
  INCOMPLETE = 'incomplete',
  BROWSED = 'browsed',
  NOT_ATTEMPTED = 'not attempted',
  UNKNOWN = 'unknown'
}
